var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewClientPaths(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    clipRule: "evenodd",
    transform: "translate(71 71) scale(0.7)",
    d: "M382 0L129 71V172H237V482H207V203H81V482H20V512H492V482H461V114H413V482H383V0H382ZM294 139H325V201H294V139ZM294 250H325V311H294V250ZM294 360H325V421H294V360ZM128 250H159V311H128V250ZM128 360H159V421H128V360Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewClientPaths);
export default __webpack_public_path__ + "static/media/New-Client-paths.d2470cc66ac69562a43e6e6af4c236b9.svg";
export { ForwardRef as ReactComponent };